module.exports = __webpack_public_path__ + "static/media/BD_website_03a_pb.b8727525.jpg";